module.exports = __webpack_public_path__ + "static/img/lzwd_qrcode.4c77e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lzwd_qrcode.jpg
// module id = 3hAb
// module chunks = 1